<template>
  <!-- 课程大纲 -->
  <div class="main-contain">
    <div class="chapters">
      <div class="intro-title">
        <el-image :src="courseImg" class="title-icon" />
        <div class="title-text"><span>课程章节</span><span class="title-count">共 {{ coursechaptersinfo.length }} 章</span>
        </div>
      </div>
      <!-- <div class="chapters-header">
        <div class="chapters-title">
          <el-image :src="courseImg" class="title-icon" />
          <span class="title-text">课程章节</span>
          <span class="title-count">共 {{ coursechaptersinfo.length }} 章</span>
        </div>
        <div class="graph-nav" @click="goGraphNav">
          <i class="el-icon-share"></i>
          <span>图谱导航</span>
        </div>
      </div> -->
      <div class="chapter" v-loading="loading" v-for="(item, index) in coursechaptersinfo"
        :key="index + '_chapter_' + item.id" :class="{ expanded: isExpanded(index) }">
        <div class="chapter-header" @click="toggleChapter(index)">
          <div class="chapter-title">
            <i class="el-icon-caret-right chapter-arrow"></i>
            <div class="chapter-num">{{ item.number }}</div>
            <span class="chapter-name">{{ item.name }}</span>
          </div>
          <div class="chapter-resources">
            <el-image class="elimage" :src="fileChaptercontent" />
            <span>章节资源：{{ getChapterResourceCount(item) }}</span>
          </div>
        </div>
        <div class="chapter-body" v-show="isExpanded(index)">
          <div class="file-list" v-if="item.outline_file_list && item.outline_file_list.length > 0">
            <div class="file-item" v-for="(iFile, iNum) in item.outline_file_list"
              :key="iNum + '_chapter_file_' + iFile.id">
              <div class="file" @click.stop="lookbt(iFile)">
                <el-image class="elimage" :src="file_icon(iFile.ext)" />
                <div class="title">{{ iFile.name }}</div>
              </div>
              <div class="file-progress">
                <span class="progress-label">学习进度</span>
                <el-progress :stroke-width="8" :percentage="iFile.progress ? parseInt(iFile.progress * 100) : 0"
                  :show-text="false" color="#10b981" />
                <span class="progress-value">{{ iFile.progress ? parseInt(iFile.progress * 100) : 0 }}%</span>
              </div>
            </div>
          </div>
          <div class="chapter-childs" v-if="item.children && item.children.length > 0">
            <div class="chapter-child" v-for="(element, idx) in item.children" :key="idx"
              :class="{ expanded: isChildExpanded(index, idx) }">
              <div class="child-header" @click.stop="toggleChild(index, idx)">
                <div class="child-title">
                  <i class="el-icon-caret-right child-arrow"></i>
                  <span class="child-num">{{ element.number }}</span>
                  <span class="child-name">{{ element.name }}</span>
                </div>
                <div class="child-progress">
                  <span class="progress-label">章节总学习进度</span>
                  <el-progress :stroke-width="6" :percentage="element.progress ? parseInt(element.progress * 100) : 0"
                    :show-text="false" color="#10b981" />
                  <span class="progress-value">{{ element.progress ? parseInt(element.progress * 100) : 0 }}%</span>
                </div>
              </div>
              <div class="file-list" v-show="isChildExpanded(index, idx)"
                v-if="element.outline_file_list && element.outline_file_list.length > 0">
                <div class="file-item" v-for="(eFile, eNum) in element.outline_file_list"
                  :key="eNum + '_chapter_file_' + eFile.id">
                  <div class="file" @click.stop="lookbt(eFile)">
                    <el-image class="elimage" :src="file_icon(eFile.ext)" />
                    <div class="title">{{ eFile.name }}</div>
                  </div>
                  <div class="file-progress">
                    <span class="progress-label">
                      <el-image class="elimage" :src="fileIcon" />
                      学习进度</span>
                    <el-progress :stroke-width="8" :percentage="eFile.progress ? parseInt(eFile.progress * 100) : 0"
                      :show-text="false" color="#10b981" />
                    <span class="progress-value">{{ eFile.progress ? parseInt(eFile.progress * 100) : 0 }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="chapter" v-if="coursechaptersinfo.length == 0">暂无章节</div> -->
      <div v-if="coursechaptersinfo.length == 0">
        <div class="is-empty" style="text-align: center">
          <img :src="no_math" />
          <div style="
            font-size: 18px;
            color: #b5a2a2;
            margin-bottom: 30px;
            text-align: center;
          ">
            <span>暂无章节数据</span>
          </div>
        </div>
      </div>
    </div>
    <Customdialog ref="customdialog" class="customdialog" @isDialogVisible="openCustomdialog" :width="videoWidth"
      type="form" title="预览" :showclose="false" @isDialogClose="close_dialog">
      <div class="dialogbody" slot="dialogbody">
        <template v-if="type == '视频' && isMobile == 1">
          <video class="video_view" ref="vueRef" id="myvideo" :src="videoviewurl" controls
            controlslist="nodownload noplaybackrate" disablepictureinpicture @play="getVidDur()"
            @pause="handleVideoPause" @timeupdate="timeUpdate" @mouseover="showMarker()" @mouseout="hideMarker()"
            @contextmenu.prevent="handleRMouse" width="100%" height="1000" />
          <div class="tips" v-if="isShow" @click.stop="hideExperiment()">关联实验 ></div>
          <div class="close_btn" v-else @click.stop="hideExperiment()">
            <span class="el-icon-circle-close"></span>
          </div>
          <div class="experiment_cont" v-if="flag && !isShow" @mouseover="showArrow()">
            <div class="item_cont">
              <div class="ex_item" v-for="(item, inx) in experimentList" :key="inx">
                <div class="ex_item_cont">
                  <div class="item_img">
                    <img :src="item.cover" alt />
                  </div>
                  <div class="item_explain">
                    <div class="name">
                      <el-tooltip :content="item.name" placement="top" effect="light" v-if="item.name.length > 7">
                        {{
                          item.name }}
                      </el-tooltip>
                      <div class="text">{{ item.name }}</div>
                      <div class="btn">
                        <el-button type="primary" @click="tourl(item)">进入实验</el-button>
                      </div>
                    </div>
                    <div class="desc">
                      <div>参与人次: {{ item.join_count }}</div>
                      <div>
                        <el-button type="text" @click="toDetail(item.vr_id)">实验详情</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ex_prev" v-if="!isShow && experimentList.length > 4" @click.stop="prev()">
            <span class="el-icon-arrow-left"></span>
          </div>
          <div class="ex_next" v-if="!isShow && experimentList.length > 4" @click.stop="next()">
            <span class="el-icon-arrow-right"></span>
          </div>
          <div class="marker_cont">
            <div class="marker_item_cont">
              <div class="m_item" v-for="(item, inx) in markerList" :key="inx" @click="showProblem(item)"
                :style="{ left: `${(item.time / duration) * 100}%` }">
                <div class="dot"></div>
              </div>
            </div>
          </div>
          <template v-if="!is_drag">
            <div class="tip_con" style="background: none; border: none">
              <div class="icon" style="background-color: red">!</div>
              <div class="tip_tex" style="color: red">初次观看视频无法快进，学习完成后才能快进！</div>
            </div>
          </template>
        </template>
        <template v-if="type == '视频' && isMobile == 0">
          <video class="video_view" ref="vueRef" id="myvideo" :src="videoviewurl" controls
            controlslist="nodownload noplaybackrate" disablepictureinpicture @play="getVidDur()"
            @pause="handleVideoPause" @timeupdate="timeUpdate" @mouseover="showMarker()" @mouseout="hideMarker()"
            @contextmenu.prevent="handleRMouse" width="100%" height="300" />
          <div class="tips" v-if="isShow" @click.stop="hideExperiment()">关联实验 ></div>
          <div class="close_btn" v-else @click.stop="hideExperiment()">
            <span class="el-icon-circle-close"></span>
          </div>
          <div class="experiment_cont" v-if="flag && !isShow" @mouseover="showArrow()">
            <div class="item_cont">
              <div class="ex_item" v-for="(item, inx) in experimentList" :key="inx">
                <div class="ex_item_cont">
                  <div class="item_img">
                    <img :src="item.cover" alt />
                  </div>
                  <div class="item_explain">
                    <div class="name">
                      <el-tooltip :content="item.name" placement="top" effect="light" v-if="item.name.length > 7">
                        {{
                          item.name }}
                      </el-tooltip>
                      <div class="text">{{ item.name }}</div>
                      <div class="btn">
                        <el-button type="primary" @click="tourl(item)">进入实验</el-button>
                      </div>
                    </div>
                    <div class="desc">
                      <div>参与人次: {{ item.join_count }}</div>
                      <div>
                        <el-button type="text" @click="toDetail(item.vr_id)">实验详情</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ex_prev" v-if="!isShow && experimentList.length > 4" @click.stop="prev()">
            <span class="el-icon-arrow-left"></span>
          </div>
          <div class="ex_next" v-if="!isShow && experimentList.length > 4" @click.stop="next()">
            <span class="el-icon-arrow-right"></span>
          </div>
          <div class="marker_cont">
            <div class="marker_item_cont">
              <div class="m_item" v-for="(item, inx) in markerList" :key="inx" @click="showProblem(item)"
                :style="{ left: `${(item.time / duration) * 100}%` }">
                <div class="dot"></div>
              </div>
            </div>
          </div>
          <template v-if="!is_drag">
            <div class="tip_con" style="background: none; border: none">
              <div class="icon" style="background-color: red">!</div>
              <div class="tip_tex" style="color: red">初次观看视频无法快进，学习完成后才能快进！</div>
            </div>
          </template>
        </template>
        <template v-if="type == '图片'">
          <!-- <el-image class="image_view" :src="imageviewurl" fit="contain" /> -->
          <iframe class="iframe_cont" :src="imageviewurl" frameborder="0" ref="myiframe"></iframe>
        </template>
        <template v-if="type == '其他'">
          <!-- <div class="tip_con">
            <div class="icon">!</div>
            <div class="tip_tex">
              该文件暂时不支持在线预览，您可以下载后查看！
            </div>
          </div>-->
          <iframe class="iframe_cont" :src="file_url" frameborder="0" ref="myiframe" width="100%"></iframe>
        </template>
        <template v-if="type == 'PDF'">
          <!-- <div class="pdf_con">
            <md-contract :url="fileurl" :visible="contractVisable" :showBtns="true" @handleModal="close">
            </md-contract>
          </div>-->
          <iframe class="iframe_cont" :src="fileurl" frameborder="0" ref="myiframe"></iframe>
        </template>
        <div id="toolbar" :class="toolbar == false ? 'tool-box doc_1' : 'tool-box'" style="visibility: visible">
          <div class="line-bar1"></div>
          <div class="full-box">
            <a class="full-btn1" @click="screen">
              <i class="el-icon-full-screen" style="font-size: 17px"></i>
              <span style="margin-left: 4px">全屏</span>
            </a>
            <!-- <a class="full-btn2" @click="fullScreen" style="display:none">
              <i class="iconfont"></i><span style="margin-left:4px">退出全屏</span>
            </a>-->
          </div>
        </div>
      </div>
      <div slot="dialogfooter" class="dialogfooter">
        <el-button type="primary" @click="download()" v-if="!is_download">下载</el-button>
        <el-button type="info" @click="close_down">关闭</el-button>
      </div>
    </Customdialog>

    <el-dialog ref="customInner" class="customInner" width="34%" title="习题" :visible.sync="innerVisible"
      @close="closeProblem" @open="openProblem" append-to-body>
      <div class="dialogbody">
        <div class="list_cont">
          <div>题号:</div>
          <div class="list_item" :class="item.check ? 'active' : ''" v-for="(item, inx) in setsList" :key="inx"
            @click="changeList(item, inx)">{{ inx + 1 }}</div>
        </div>
        <div class="list_exercises">
          <TabsProblem v-if="problem" :info="info" @checkMsg="checkMsg"></TabsProblem>
        </div>
      </div>
      <div class="dialogfooter">
        <el-button type="primary" @click="prevProblem" v-if="setsIndex">上一题</el-button>
        <el-button type="primary" @click="nextProblem">下一题</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import Customdialog from "@/components/customdialog.vue"
import {
  getoutlinelist,
  currentProgress,
  getOutlineTimelist,
  getTimeVrList,
  getProgressList
} from "@/api/outline"
import mdContract from "@/contract.md.vue"
import { getToken } from "@/utils/auth"
import { getvrmodulelink, getCourseVrModuleList, getVRList } from "@/api/vr"
import TabsProblem from "./tabsProblem.vue"
import { Base64 } from "js-base64"
import screenfull from "screenfull"
const request_base_path = require("@/utils/base_url")
export default {
  name: "courseoutline",
  components: {
    Customdialog,
    mdContract,
    TabsProblem,
  },
  data() {
    return {
      filePreview: "", // 数据预览
      picturesPreview: "", // 多图预览
      fileTask: "", // 数据预埋

      token: getToken() ? true : false,
      fileurl: "",
      file_url: "",
      type: "",
      videoviewurl: "",
      imageviewurl: "",
      coursechaptersinfo: "",
      imageviewurlList: [], // 图片数据
      isImg: ["jpg", "png", "jpeg", "gif", "webp"],
      viewicon: require("@/assets/查看.png"),
      // icon1: require("@/assets/coursedetails/文件类型-标准图-视频文件.png"),
      // icon2: require("@/assets/coursedetails/文件类型-标准图-Word文档.png"),
      // icon3: require("@/assets/coursedetails/文件类型-标准图-幻灯片.png"),
      // icon4: require("@/assets/coursedetails/文件类型-标准图-声音文件.png"),
      // icon5: require("@/assets/coursedetails/文件类型-标准图-图片文件.png"),
      fileicon1: require("@/assets/fileicon/files.png"),
      fileicon2: require("@/assets/course/UIout/fileicon/pdf.png"),
      fileicon3: require("@/assets/course/UIout/fileicon/word.png"),
      fileicon4: require("@/assets/course/UIout/fileicon/mp4_ico.png"),
      fileicon5: require("@/assets/course/UIout/fileicon/img_ico.png"),
      fileicon6: require("@/assets/fileicon/icon-node.png"),
      fileicon7: require("@/assets/fileicon/icon-audio.png"),
      fileicon8: require("@/assets/fileicon/icon-chapter.png"),
      fileicon9: require("@/assets/fileicon/rar.png"),
      fileicon10: require("@/assets/course/UIout/fileicon/img_ico.png"),
      fileicon11: require("@/assets/course/UIout/fileicon/txt.png"),
      fileicon12: require("@/assets/course/UIout/fileicon/excel.png"),
      fileicon13: require("@/assets/course/UIout/fileicon/other_btn.png"),
      fileIcon: require("@/assets/course/UIout/class/class_ico_progress.png"),
      fileChaptercontent: require("@/assets/course/UIout/class/chaptercontent_ico.png"), // 章节目录
      no_math: require("@/assets/no_math1.png"), // 没有公式
      outline_file_id: "",
      courseKey: "",
      outline_file_len: "",
      progress: "",
      is_download: 0,
      itemObj: {},
      isShow: false,
      experimentList: [],
      currentIndex: 0,
      speedW: 0,
      player: null,
      markerList: [],
      duration: 0,
      innerVisible: false,
      setsList: [],
      setsIndex: null,
      // id: null,
      info: {},
      obj: [],
      currentTime: 0,
      noFirstPlay: false, // 是否第一次播放
      checkMsgData: false,
      experTotal: [],
      flag: false,
      maxTime: 0,
      problem: false,
      fullscreen: false, //全屏
      toolbar: false,
      is_drag: 0,
      learn_time: 0,
      videoWidth: "",
      isMobile: "", // 判断手机端字段
      outline_id_list: '', //章节id
      outline_file_id_list: '', //资料id
      videoProgress: null, //进度条
      isCurVideoEnd: false, //当前视频是否播放完毕
      isVideoEnded: false, //视频是否已经结束（用于防止重复调用进度更新接口）
      courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),//课程介绍背景图
      expandedChapters: [0], // 默认展开第一个章节
      expandedChildren: {}, // 子章节展开状态 { chapterIndex: [childIndex, ...] }
      loading: false,
    }
  },
  filters: {},
  watch: {
    setsIndex: {
      handler(val) {
        if (val === null) return false
        this.info = this.obj.filter((item, index) => {
          if (index === val) {
            return item
          }
        })
      },
      immediate: true,
      deep: true,
    },
    currentTime: {
      handler(val) {
        if (!val) return false
        //console.log('currentTime-----', val)
        this.markerList.forEach((item) => {
          if (item.time === Math.trunc(val)) {
            if (item.time === Math.round(val)) {
              this.player.pause()
              this.player.currentTime = val + 0.5 // 自动快进1s防止习题时间点重复触发
              this.showProblem(item)
            }
          }
        })

        this.experTotal.forEach((item) => {
          if (item.time === Math.trunc(val)) {
            if (item.time === Math.round(val)) {
              item.vr_list.forEach((el) => {
                this.experimentList.push(el)
              })
              this.flag = true
              this.player.pause()
              this.player.currentTime = val + 0.5 // 自动快进1s防止实验时间点重复触发
              //console.log('this.experimentList----', this.experimentList)
            }
          }
        })
      },
      immediate: true,
      deep: true,
    },
    experimentList: {
      handler(val) {
        this.$nextTick(() => {
          let htmlW = document.documentElement.clientWidth
          if (!val.length) return false
          let t_dis = document.querySelector(".experiment_cont")
          let t_w = t_dis.offsetWidth
          let dis = document.querySelector(".item_cont")
          let disArr = document.querySelectorAll(".ex_item")

          if (htmlW < 1900) {
            this.speedW = `${(t_w - 24) / 3}`
            disArr.forEach((item) => {
              item.style["width"] = `${(t_w - 24) / 3}px`
            })
          } else {
            this.speedW = `${(t_w - 34) / 4}`
            disArr.forEach((item) => {
              item.style["width"] = `${(t_w - 34) / 4}px`
            })
          }
          let is_w = disArr[0].offsetWidth
          dis.style["width"] = `${is_w * disArr.length + (disArr.length + 1) * 10
            }px`
        })
      },
      immediate: true,
      deep: true,
    },
    player: {
      handler(newV) {
        if (newV) {
          let that = this
          newV.addEventListener('ended', function (e) {
            that.isCurVideoEnd = true
            // 标记视频已结束，防止后续重复调用
            that.isVideoEnded = true
            // 清除定时器，避免重复调用
            if (that.videoProgress) {
              clearInterval(that.videoProgress)
              that.videoProgress = null
            }
            const params = {
              outline_file_id: that.outline_file_id,
              time: that.currentTime,
            }
            if (that.currentTime) that.setCurrentProgress(params, false)
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    if (this.videoProgress) clearInterval(this.videoProgress)
    if (this.player === null) return false
    else {
      this.player.pause()
    }
  },
  created() {
    const systemConfig = sessionStorage.getItem("systemConfig")
    const systemInfo = systemConfig ? JSON.parse(systemConfig) : {}
    if (systemInfo.file_preview_url) {
      this.filePreview = systemInfo.file_preview_url + "/onlinePreview?url=" // 数据预览
      this.picturesPreview =
        systemInfo.file_preview_url + "/picturesPreview?urls=" // 多图预览
      this.fileTask = systemInfo.file_preview_url + "/addTask?url=" // 数据预埋
    } else {
      this.filePreview =
        request_base_path.pro_url + "/file-preview/onlinePreview?url=" // 数据预览
      this.picturesPreview =
        request_base_path.pro_url + "/file-preview/picturesPreview?urls=" // 多图预览
      this.fileTask = request_base_path.pro_url + "/file-preview/addTask?url=" // 数据预埋
    }
    if (this._isMobile()) {
      this.isMobile = 0
      this.videoWidth = 100 + "%"
    } else {
      this.isMobile = 1
      this.videoWidth = 70 + "%"
    }
    // this.getVR()
  },
  methods: {
    // 初始化数据
    initdata(obj, courseKey) {
      if (courseKey) {
        // this.infoData = obj;
        this.courseKey = courseKey
        this.expandedChapters = [0]
        this.expandedChildren = {}
        this.getoutlinelist()
      }
    },
    // 章节是否展开
    isExpanded(index) {
      return this.expandedChapters.includes(index)
    },
    // 切换章节展开/折叠
    toggleChapter(index) {
      const i = this.expandedChapters.indexOf(index)
      if (i > -1) {
        this.expandedChapters.splice(i, 1)
      } else {
        this.expandedChapters.push(index)
      }
    },
    // 子章节是否展开
    isChildExpanded(chapterIndex, childIndex) {
      const list = this.expandedChildren[chapterIndex]
      return Array.isArray(list) && list.includes(childIndex)
    },
    // 切换子章节展开/折叠
    toggleChild(chapterIndex, childIndex) {
      if (!this.expandedChildren[chapterIndex]) {
        this.$set(this.expandedChildren, chapterIndex, [])
      }
      const list = this.expandedChildren[chapterIndex]
      const i = list.indexOf(childIndex)
      if (i > -1) {
        list.splice(i, 1)
      } else {
        list.push(childIndex)
      }
    },
    // 统计章节资源数量（包含子章节资料）
    getChapterResourceCount(item) {
      let count = 0
      if (item.outline_file_list) {
        count += item.outline_file_list.length
      }
      if (item.children) {
        item.children.forEach((child) => {
          if (child.outline_file_list) {
            count += child.outline_file_list.length
          }
        })
      }
      return count
    },
    // 图谱导航
    goGraphNav() {
      this.$message.info("图谱导航功能开发中")
    },
    // 获取课程章节列表
    getoutlinelist() {
      const params = {
        course_semester_sn: this.courseKey,
        is_show_progress: 1,
      }
      this.loading = true
      let outline_id_data = []
      let outline_file_id_data = []
      getoutlinelist(params)
        .then((response) => {
          this.loading = false
          this.coursechaptersinfo = response.data
          // 默认展开所有子章节
          const expandedChildren = {}
          response.data.forEach((item, index) => {
            outline_id_data.push(item.id)
            if (item.children && item.children.length > 0) {
              expandedChildren[index] = item.children.map((_, idx) => idx)
            }
            item.children.forEach((el) => {
              outline_id_data.push(el.id)
              el.outline_file_list.forEach((items) => {
                outline_file_id_data.push(items.id) // 章节资料id
                if (this.isImg.includes(items.ext)) {
                  this.imageviewurlList.push(items.url)
                }
              })
            })
          })
          this.expandedChildren = expandedChildren
          this.outline_id_list = outline_id_data
          this.outline_file_id_list = outline_file_id_data
          // 实时更新进度
          // this.getProgressList();
        })
        .catch((error) => {
          this.loading = false
          //console.log(error)
        })
    },
    // 实时更新进度
    getProgressList() {
      let params = { outline_file_id: this.outline_file_id_list.toString(), outline_id: this.outline_id_list.toString() }
      getProgressList(params).then(res => {
        if (res.code === 0) {
          console.log('res.data', res.data, this.coursechaptersinfo)
          this.coursechaptersinfo.forEach(item => {
            res.data.outline_progress.forEach(els => {
              if (els.outline_id === item.id) {
                item.progress = els.rate
                item.learn_time = els.time
              }
            })
            item.children.forEach(el => {
              res.data.outline_progress.forEach(elss => {
                if (elss.outline_id === el.id) {
                  el.progress = elss.rate
                  el.learn_time = elss.time
                }
              })
              el.outline_file_list.forEach(items => {
                res.data.outline_file_progress.forEach(ites => {
                  if (items.id === ites.outline_file_id) {
                    items.progress = ites.rate
                    items.learn_time = ites.time
                  }
                })
              })
            })
          })
        }
      })
    },
    // 判断手机端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    async updateTimeVrList(data) {
      let params = {
        time: null,
        outline_file_id: data,
      }
      await getTimeVrList(params)
        .then((res) => {
          this.experTotal = res.data
        })
        .catch((error) => { })
    },
    getVR() {
      getVRList({ course_semester_sn: this.courseKey })
        .then((res) => {
          this.experimentList = res.data.data
          this.getCourseVr()
        })
        .catch((error) => { })
    },
    getCourseVr() {
      getCourseVrModuleList({ course_semester_sn: this.courseKey })
        .then((res) => {
          let resArr = res.data
          resArr.forEach((item) => {
            this.experimentList.forEach((el) => {
              if (el.name === item.name) {
                el.vr_id = item.id
              }
            })
          })
        })
        .catch((err) => { })
    },
    openCustomdialog(val) {
      if (this.type != "视频") {
        return false
      }
      let that = this
      that.$nextTick(() => {
        that.player = document.getElementById("myvideo")
        that.player.addEventListener("loadedmetadata", function () {
          that.duration = parseInt(this.duration) //获取总时长
          let resCurrent = that.learn_time // Math.floor(that.duration * that.progress * 100) / 100 // 临时放开禁止视频快进
          that.currentTime = resCurrent
          that.player.currentTime = resCurrent
        })
      })
    },
    //视频进度历史
    getVidDur() {
      this.videoProgress = setInterval(() => {
        // 如果视频已结束，不再调用进度更新接口
        if (this.isVideoEnded) {
          if (this.videoProgress) {
            clearInterval(this.videoProgress)
            this.videoProgress = null
          }
          return
        }
        // 当 learn_time 与 length 相等时（视频已播放完成），清除定时器并返回
        if (this.learn_time === this.outline_file_len && this.outline_file_len > 0) {
          if (this.videoProgress) {
            clearInterval(this.videoProgress)
            this.videoProgress = null
          }
          return
        }
        // 如果当前播放进度小于已记录的学习时间（快退），不调用进度更新接口
        if (this.currentTime < this.learn_time) {
          return
        }
        // 当视频接近结尾（剩余时间小于5秒），清除定时器，避免频繁调用
        if (this.duration > 0 && this.currentTime >= this.duration - 5) {
          if (this.videoProgress) {
            clearInterval(this.videoProgress)
            this.videoProgress = null
          }
          return
        }
        const params = {
          outline_file_id: this.outline_file_id,
          time: this.currentTime,
        }
        if (this.currentTime) this.setCurrentProgress(params, false)
      }, 5000)
      // 判断视频是否已加载完成
      if (this.progress == 1) {
        setTimeout(() => {
          if (this.player.currentTime > this.currentTime) {
            this.player.currentTime = 0
          }
          return false
        }, 150)
      } else {
        if (this.noFirstPlay) {
          // 不是第一播放
          if (!this.is_drag) {
            // if (this.learn_time === this.outline_file_len && this.outline_file_len > 0) {
            //   return
            // }
            // is_drag: 0, 不可拖拽 1, 可拖拽
            this.player.currentTime = this.currentTime
          }
        }
        // else { // 第一播放，自动跳转到上次播放时间
        //   if (this.progress >= 0) {
        //     let num = this.player.duration * this.progress ? this.player.duration * this.progress : this.currentTime
        //     this.player.currentTime = Math.floor(num * 100) / 100
        //   }
        // }
      }
      this.noFirstPlay = true
    },
    handleVideoPause() {
      if (this.videoProgress) clearInterval(this.videoProgress)
    },
    timeUpdate(e) {
      // 判断视频是否可拖拽 is_drag: 0, 不可拖拽 1, 可拖拽
      // 判断视频是否已加载完成
      if (this.is_drag != 1 && this.progress != 1) {
        // 判断当前进度是否大于记录的最大进度
        if (e.srcElement.currentTime > this.maxTime) {
          // 通过记录当前时间与下一次播放时间的差值判断是否拖拽或快进
          if (e.srcElement.currentTime - this.currentTime > 1) {
            e.srcElement.currentTime =
              this.currentTime > this.maxTime ? this.currentTime : this.maxTime
          }
          this.currentTime = e.srcElement.currentTime
          this.maxTime =
            this.currentTime > this.maxTime ? this.currentTime : this.maxTime
        } else {
          this.currentTime = e.srcElement.currentTime
        }
      }
    },
    file_icon(val) {
      switch (val) {
        case "file":
          return this.fileicon1

        case "pdf":
          return this.fileicon2

        case ("word", "docx"):
          return this.fileicon3

        case "mp4":
          return this.fileicon4

        case ("png", "jpg"):
          return this.fileicon5

        case "radio":
          return this.fileicon7

        case "rar":
          return this.fileicon9

        case "txt":
          return this.fileicon11

        case "xlsx":
          return this.fileicon12

        case "zip":
          return this.fileicon13

        default:
          return this.fileicon10
      }
    },
    async lookbt(item) {
      this.isCurVideoEnd = false
      this.isVideoEnded = false // 重置视频结束标志
      this.is_drag = item.is_drag
      this.resetFill()
      await this.getTask(item.url)
      if (item.progress !== null || item.progress !== "") {
        this.progress = Number(item.progress)
      } else {
        this.progress = 0
      }
      if (item.learn_time) {
        this.learn_time = Number(item.learn_time)
      }
      this.outline_file_id = item.id
      this.outline_file_len = item.length
      if (item.ext == "mp4" || item.ext == "avi" || item.ext == "flv") {
        await this.updateMarker(item.id)
        await this.updateTimeVrList(item.id)
        this.type = "视频"
        this.videoviewurl = item.url
        this.toolbar = false
      } else if (item.ext == "png" || item.ext == "jpg") {
        this.type = "图片"
        // this.imageviewurl = item.url
        let len = this.imageviewurlList.length
        for (let i = 0; i < this.imageviewurlList.length; i++) {
          if (this.imageviewurlList[i] == item.url) {
            let newArr = this.imageviewurlList.splice(i, len - i)
            let oldArr = this.imageviewurlList
            this.imageviewurlList = [...newArr, ...oldArr]
            break
          }
        }
        let url = this.imageviewurlList.join("|")
        this.imageviewurl =
          this.picturesPreview + encodeURIComponent(Base64.encode(url))
        this.toolbar = true
      } else if (item.ext == "pdf") {
        this.type = "PDF"
        this.fileurl =
          this.filePreview + encodeURIComponent(Base64.encode(item.url))
        this.toolbar = true
      } else {
        this.type = "其他"
        this.file_url =
          this.filePreview + encodeURIComponent(Base64.encode(item.url))
        this.toolbar = true
      }
      this.itemObj = item
      this.is_download = item.is_download
      this.$refs.customdialog.dialogopenbt()
    },
    resetFill() {
      this.imageviewurl = ""
      this.fileurl = ""
      this.file_url = ""
    },
    getTask(data) {
      this.fileTask + data
    },
    // 下载
    download() {
      let row = this.itemObj
      //1.先创建一个a标签
      let a = document.createElement("a")
      a.target = "_bank"
      a.download = row.name
      //2.给a标签的href赋上下载地址
      a.href = row.url
      //3.让a标签不显示在视图中
      a.style.display = "none"
      //4.将a标签append到文档中
      document.body.appendChild(a)
      //5.a标签自点击
      a.click()
      //6.点击下载后，销毁这个节点
      document.body.removeChild(a)
    },
    resetVideo() {
      this.learn_time = 0
      this.currentTime = 0
      this.maxTime = 0
      if (this.player?.currentTime) {
        this.player.currentTime = 0
      }
      this.player = null
      if (this.videoProgress) clearInterval(this.videoProgress)
    },
    close_dialog() {
      this.resetFill()
    },
    close_down() {
      this.flag = false
      this.experimentList = []
      this.noFirstPlay = false
      this.$refs.customdialog.dialogclosebt()
      let videoTime = document.getElementById("myvideo")
      if (this.videoviewurl !== "") {
        if (videoTime.currentTime) {
          this.$refs.vueRef.pause() //暂停
          // 如果视频已结束，不再调用进度更新接口
          if (this.isVideoEnded) {
            this.resetVideo()
            return
          }
          const params = {
            outline_file_id: this.outline_file_id,
            time: videoTime.currentTime,
          }
          if (!this.isCurVideoEnd) this.setCurrentProgress(params, true) // 如果当前视频资料播放完成关闭弹窗不再调用更新进度接口
        }
        // 如果视频已结束，直接重置视频
        if (this.isVideoEnded) {
          this.resetVideo()
          return
        }
        this.resetVideo()
      } else {
        const params = {
          outline_file_id: this.outline_file_id,
        }
        if (this.progress === "" || this.progress < 1) {
          params.time = this.outline_file_len ? this.outline_file_len : 1 // 未打开过小节(未读)或未完成100%
          this.setCurrentProgress(params, true)
        }
      }
      this.videoviewurl = ""
      setTimeout(() => {
        this.itemObj = {}
        this.is_download = 0
      }, 500)
    },
    async setCurrentProgress(data, flag) {
      await currentProgress(data)
        .then((res) => {
          if (res.code === 0) {
            // this.$message.success('进度上传成功!')
            if (flag) this.getoutlinelist() // 更新
          }
        })
        .catch(() => { })
    },
    hideExperiment() {
      this.isShow = !this.isShow
    },
    showArrow() {
      if (this.experimentList.length < 4) return false
      let dis_prev = document.querySelector(".ex_prev")
      let dis_next = document.querySelector(".ex_next")
      dis_prev.style["display"] = "block"
      dis_next.style["display"] = "block"
      setTimeout(() => {
        dis_prev.style["display"] = "none"
        dis_next.style["display"] = "none"
      }, 5000)
    },
    prev() {
      //console.log('this.currentIndex', this.currentIndex)
      if (!this.currentIndex) {
        this.$message.warning("这是第一组实验了!")
        return false
      }
      this.currentIndex--
      let dis = document.querySelector(".item_cont")
      if (!this.currentIndex) {
        dis.style["transform"] = `translateX(0px)`
      } else {
        let res = -(this.speedW * this.currentIndex + this.currentIndex * 10)
        dis.style["transform"] = `translateX(${res}px)`
      }
      //console.log('this.currentIndex--', this.currentIndex)
    },
    next() {
      //console.log('this.currentIndex', this.currentIndex)
      let len = this.experimentList.length - 1
      if (this.currentIndex === len) {
        this.$message.warning("这是最后一组实验了!")
        return false
      }
      this.currentIndex++
      let dis = document.querySelector(".item_cont")
      dis.style["transform"] = `translateX(-${this.speedW * this.currentIndex + this.currentIndex * 10
        }px)`
      //console.log('this.currentIndex++', this.currentIndex)
    },
    toDetail(id) {
      this.player.pause()
      let path = "/home/virtualsimulationexperiment/experimentdetails"
      window.open(
        request_base_path.pro_url + "#" + path + `?id=${id}`,
        "_blank"
      )
    },
    tourl(item) {
      this.player.pause()
      let params = { id: item.vr_module_id }
      getvrmodulelink(params)
        .then((response) => {
          if (response.data) {
            window.open(response.data.url, "_blank")
          }
        })
        .catch(() => { })
    },
    showProblem(item) {
      this.setsList = []
      if (item.stem_list.length) {
        item.stem_list.forEach((el) => {
          this.setsList.push({
            id: el.stem_id,
            check: false,
          })
          this.setsList[0].check = true
        })
      }
      this.obj = item.stem_list
      this.innerVisible = true
    },
    changeList(data, inx) {
      this.setsIndex = inx
      this.id = data.id
      this.setsList.forEach((item) => {
        item.check = false
      })
      data.check = true
    },
    checkMsg(data) {
      this.checkMsgData = data
    },
    prevProblem() {
      // if (!this.checkMsgData) {
      //   this.$message.warning('请选择选项!')
      //   return false
      // }
      this.setsIndex--
      let arr = this.setsList
      arr.forEach((item, index) => {
        item.check = false
        if (this.setsIndex === index) {
          item.check = true
        }
      })
      // this.checkMsgData = false
    },
    nextProblem() {
      // if (!this.checkMsgData) {
      //   this.$message.warning('请选择选项!')
      //   return false
      // }
      this.setsIndex++
      let arr = this.setsList
      arr.forEach((item, index) => {
        item.check = false
        if (this.setsIndex === index) {
          item.check = true
        }
      })
      // this.checkMsgData = false
      if (this.setsIndex === arr.length) {
        this.innerVisible = false
      }
    },
    openProblem() {
      this.problem = true
      this.setsIndex = 0
      this.setsList.forEach((item, index) => {
        item.check = false
        if (this.setsIndex === index) {
          item.check = true
        }
      })
    },
    closeProblem() {
      this.problem = false
      this.setsIndex = null
      this.player.play()
    },
    // 视频上鼠标悬停
    showMarker() {
      return false
    },
    // 视频上鼠标退出
    hideMarker() {
      return false
    },
    // 视频上右键打开菜单
    handleRMouse(e) {
      e.preventDefault()
    },
    async updateMarker(id) {
      await getOutlineTimelist({ outline_file_id: id })
        .then((res) => {
          this.markerList = res.data
        })
        .catch((error) => { })
    },

    //全屏
    screen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.$refs.myiframe)
      }
    },
  },
};
</script>
<style scoped lang="scss">
.main-contain {
  // height: 100%;
  // border: 1px solid transparent;
  background: #FFFFFF;
  // box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
  border-radius: 12px 12px 12px 12px;
  margin-top: 10px;

  .chapters {
    background: url(~@/assets/course/UIout/class/class_decor_02.png) no-repeat;
    background-position: right bottom;
    min-height: 400px;
    padding: 16px;


    .chapters-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .chapters-title {
        display: flex;
        align-items: center;
        gap: 10px;

        .title-icon {
          width: 36px;
          height: 36px;
        }

        .title-text {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
        }

        .title-count {
          font-size: 14px;
          color: #999999;
        }
      }

      .graph-nav {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          color: #6a5af9;
          border-color: #6a5af9;
        }

        i {
          font-size: 16px;
          color: #6a5af9;
        }
      }
    }

    .intro-title {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 25px;

      .title-icon {
        position: absolute;
      }

      .title-text {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        position: relative;
        left: 5%;
      }

      i {
        margin-right: 8px;
        color: #7b5cff;
        font-size: 20px;
      }

      .title-count {
        font-weight: 500;
        font-size: 16px;
        color: #AAAAAA;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding-left: 10px;
      }
    }

    .chapter {
      margin-bottom: 16px;
      background: #f8f7ff;
      border: 1px solid #e8e4ff;
      border-radius: 16px;
      overflow: hidden;
      transition: all 0.3s;

      &.expanded {
        background: #ffffff;
        border-color: #d1cafc;
        box-shadow: 0 4px 20px rgba(106, 90, 249, 0.08);
      }

      .chapter-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        cursor: pointer;
        user-select: none;

        &:hover {
          background: rgba(106, 90, 249, 0.03);
        }

        .chapter-title {
          display: flex;
          align-items: center;
          gap: 10px;

          .chapter-num {
            // width: 28px;
            // height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            // background: linear-gradient(135deg, #8b7cff 0%, #6a5af9 100%);
            // border-radius: 50%;
            font-size: 14px;
            font-weight: 600;
            // color: #ffffff;
          }

          .chapter-arrow {
            font-size: 30px;
            color: #6a5af9;
            transition: transform 0.3s;
          }

          .chapter-name {
            font-size: 16px;
            font-weight: 600;
            color: #333333;
          }
        }

        .chapter-resources {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 14px;
          background: rgba(106, 90, 249, 0.08);
          border-radius: 16px;
          font-size: 13px;
          color: #6a5af9;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;

          i {
            font-size: 16px;
          }
        }
      }

      &.expanded .chapter-header .chapter-title .chapter-arrow {
        transform: rotate(90deg);
      }

      .chapter-body {
        padding: 0 20px 20px;

        .file-list {
          .file-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
              border-bottom: none;
            }

            .file {
              display: flex;
              align-items: center;
              cursor: pointer;

              .elimage {
                width: 35px;
                height: 35px;
                margin: 0 12px;
              }

              .title {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                text-align: left;
                font-style: normal;
                text-transform: none;
                transition: color 0.3s;
              }

              &:hover .title {
                color: #6a5af9;
              }
            }

            .file-progress {
              display: flex;
              align-items: center;
              gap: 10px;
              min-width: 200px;

              .progress-label {
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }

              ::v-deep .el-progress {
                flex: 1;
              }

              .progress-value {
                font-weight: 400;
                font-size: 14px;
                color: #AAAAAA;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }
          }
        }

        .chapter-childs {
          margin-top: 10px;

          .chapter-child {
            padding: 12px 16px;
            background: #fbfaff;
            border: 1px solid #edeaff;
            border-radius: 12px;
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }

            .child-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 8px;
              cursor: pointer;
              user-select: none;

              .child-title {
                display: flex;
                align-items: center;
                gap: 8px;

                .child-arrow {
                  font-size: 18px;
                  color: #aaaaaa;
                  transition: transform 0.3s;
                }

                .child-num {
                  font-size: 14px;
                  font-weight: 600;
                  color: #6a5af9;
                  font-weight: 500;
                  font-size: 16px;
                  color: #333333;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }

                .child-name {
                  font-size: 14px;
                  color: #333333;
                  font-weight: 500;
                  font-size: 16px;
                  color: #333333;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }

              .child-progress {
                display: flex;
                align-items: center;
                gap: 10px;
                min-width: 300px;
              }

              .progress-label {
                font-weight: 400;
                font-size: 14px;
                color: #555555;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }

              ::v-deep .el-progress {
                flex: 1;
              }

              .progress-value {
                font-weight: 400;
                font-size: 14px;
                color: #AAAAAA;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }

            &.expanded .child-header .child-title .child-arrow {
              transform: rotate(90deg);
            }

            .file-list {
              padding-left: 22px;

              .file-item {
                padding: 10px 0;
              }
            }
          }
        }
      }
    }
  }

  .tools {
    // text-align: right;
    width: 150px;
  }

  .customdialog {
    .dialogbody {
      // border: 1px solid red;
      padding: 10px;

      .image_view {
        height: 600px;
        width: 100%;
      }

      .pdf_con {
        // border: 1px solid red;
        position: relative;
      }

      .tip_con {
        height: 60px;
        background: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
          margin-right: 10px;
          width: 20px;
          height: 20px;
          line-height: 17px;
          text-align: center;
          border-radius: 50%;
          background: #1890ff;
          color: white;
        }

        .tip_tex {
          font-size: 20px;
          font-weight: bold;
          color: #999999;
        }
      }
    }

    .dialogfooter {
      // border: 1px solid red;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.toolbar {
  padding: 20px 0px 10px 0px;
}

.full-box {
  display: flex;
  justify-content: flex-end;
}

::v-deep .base-dialog-form {
  margin-top: 3vh !important;
}

.iframe_cont {
  height: 1000px;
}

/* 响应式 */
@media screen and (max-width: 1200px) {
  .main-contain {
    .chapters {
      .chapter {
        .chapter-header {
          .chapter-title {
            .chapter-num {
              width: 36px;
              height: 36px;
              line-height: 36px;
              font-size: 16px;
            }

            .chapter-name {
              font-size: 16px;
            }
          }
        }

        .chapter-content {
          .file-item {
            .file-info {
              .file-name {
                font-size: 14px;
              }
            }

            .file-progress {
              .progress-text {
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .main-contain {
    .chapters {
      padding: 12px;

      .intro-title {
        .title-text {
          font-size: 16px;

          .title-count {
            font-size: 13px;
          }
        }
      }

      .chapter {
        .chapter-header {
          padding: 12px;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;

          .chapter-title {
            .chapter-num {
              width: 32px;
              height: 32px;
              line-height: 32px;
              font-size: 14px;
            }

            .chapter-name {
              font-size: 15px;
            }
          }

          .chapter-resources {
            font-size: 13px;
          }
        }

        .chapter-content {
          padding: 12px;

          .file-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;

            .file-info {
              .file-name {
                font-size: 13px;
              }
            }

            .file-progress {
              width: 100%;

              .progress-bar {
                width: 120px;
              }

              .progress-text {
                font-size: 12px;
              }
            }
          }

          .chapter-child {
            .child-header {
              .child-title {
                .child-name {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }

  .iframe_cont {
    height: 500px;
  }

  .video_view {
    height: 220px !important;
  }
}

@media screen and (max-width: 480px) {
  .main-contain {
    .chapters {
      padding: 8px;

      .intro-title {
        .title-text {
          font-size: 15px;
        }
      }

      .chapter {
        .chapter-header {
          padding: 10px;

          .chapter-title {
            .chapter-num {
              width: 28px;
              height: 28px;
              line-height: 28px;
              font-size: 13px;
            }

            .chapter-name {
              font-size: 14px;
            }
          }
        }

        .chapter-content {
          padding: 10px;

          .file-item {
            .file-info {
              .file-name {
                font-size: 12px;
              }
            }

            .file-progress {
              .progress-bar {
                width: 80px;
              }
            }
          }
        }

        .empty {
          text-align: center;
          padding: 60px 0;
          color: #999999;
          font-size: 14px;
        }
      }
    }
  }

  .iframe_cont {
    height: 300px;
  }
}
</style>